import styled from 'styled-components'

import AddressSummaryDisplay from 'checkout/components/ShippingAddressPanel/AddressSummaryDisplay'
import Divider from 'shared/components/Divider'
import PaymentSummary from 'checkout/components/PaymentMethodPanel/PaymentSummary'
import PaymentType from 'shared/enums/PaymentType'
import { Address } from 'shared/types/Address'
import { BillingInfo } from 'shared/types/BillingInfo'

type PaymentMethodSummaryProps = {
  billingAddress: Address
  billingInfo: BillingInfo
}

export const PaymentMethodSummary = ({
  billingAddress,
  billingInfo,
}: PaymentMethodSummaryProps) => {
  if (!billingInfo) {
    return null
  }

  return (
    <>
      <PaymentSummary billingInfo={billingInfo} />
      {billingInfo.paymentType === PaymentType.CreditCard && !!billingAddress && (
        <>
          <Divider />
          <CardAddressSummary
            qaAttr="BillingAddress"
            name={billingAddress.name}
            address1={billingAddress.address1}
            address2={billingAddress.address2}
            city={billingAddress.city}
            state={billingAddress.state}
            postalCode={billingAddress.postalCode || ''}
            country={billingAddress.countryCode}
            phone={billingAddress.phone}
          />
        </>
      )}
    </>
  )
}

const CardAddressSummary = styled(AddressSummaryDisplay)`
  margin: 25px 0 0;
`
